var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M90,37.5A17.5,17.5,0,1,1,107.5,20,17.521,17.521,0,0,1,90,37.5M90,0A20,20,0,1,1,70,20,20.023,20.023,0,0,1,90,0Zm7.133,25.366-5.883-5.882V8.751a1.25,1.25,0,1,0-2.5,0V20a1.246,1.246,0,0,0,.365.882l6.25,6.25a1.25,1.25,0,1,0,1.768-1.768Z",
    transform: "translate(-70)",
    fill: "#444141",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/Clock Icon.0cea4fab35c238caac8183d6db181474.svg";
export { ForwardRef as ReactComponent };